import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import Header from "../components/Header";
const PrivateRoute = ({ children, ...rest }) => {
  const location = useLocation();
  const current_url = location.pathname.split("/")[1];

  let { user } = useContext(AuthContext);


  return !isEmpty(user) ? (
    <>
      {!["transaction-logs"].includes(current_url) ? <Header /> : null}

      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
